import { render, staticRenderFns } from "./question-qa.vue?vue&type=template&id=c0b4f562&scoped=true&"
import script from "./question-qa.vue?vue&type=script&lang=js&"
export * from "./question-qa.vue?vue&type=script&lang=js&"
import style0 from "./question-qa.vue?vue&type=style&index=0&id=c0b4f562&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b4f562",
  null
  
)

export default component.exports